import { message } from 'antd';

export const errorHandlingService = {
  handleError: (error: any) => {
    console.error('An error occurred:', error);

    let errorMessage = 'Si è verificato un errore. Riprova più tardi.';

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorMessage = error.response.data.message || errorMessage;
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = 'Nessuna risposta ricevuta dal server. Verifica la tua connessione.';
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMessage = error.message;
    }

    message.error(errorMessage);
  }
};